/*eslint-disable*/
import React, {Component} from "react";
import {Collapse, Nav} from "react-bootstrap";
import {NavLink} from "react-router-dom";
import AdminNavbarLinks from "../Navbar/AdminNavbarLinks.jsx";

// image for avatar in Sidebar
import avatar from "../../assets/img/default-avatar.png";
import {API} from "../../lib/API";
import {mauiRoutes} from "../../routes.js";
import {withTranslation} from 'react-i18next';
import {capitalizeWords, getPossibleTimezone} from "../../lib/common";

const localStorage = require('../../lib/localStorage');
let routes = mauiRoutes.getRoutes();
var ps;

const GenerateSidebarLinks = ({ csRoutes, currentRoute, handleClick }) => (
    csRoutes.map((routeItem) => {
        const isActive = currentRoute.id === routeItem.id;

        return (
            <li key={routeItem.id}>
                <div className="nav-link-wrapper">
                    <button
                        id={routeItem.id}
                        onClick={handleClick}
                        type="button"
                        className={`nav-link d-flex align-items-center gap-2 sidebar-button${isActive ? " active" : ""}`}
                        aria-current={isActive ? "page" : undefined}
                    >
                        <span className="me-2" aria-hidden="true">&nbsp;</span>
                        <span className="sidebar-normal">
                          {capitalizeWords(routeItem.sbLinkName)}
                        </span>
                    </button>
                </div>
            </li>
        );
    })
);

const BuildSideBarMenus = ({
                               width,
                               loaded,
                               createLinks,
                               createAdminSettingLinks,
                               createHelpLinks,
                               trans
                           }) => (
    <Nav as="ul">
        {loaded && (
            <>
                {width <= 992 && <AdminNavbarLinks t={trans} />}
                {createLinks(routes, false, false)}
                {createAdminSettingLinks(routes)}
                {createHelpLinks(routes)}
            </>
        )}
    </Nav>
);

class Sidebar extends Component {
    constructor(props) {
        super(props);

        this.sidebarWrapperRef = React.createRef();

        this.state = {
            ...this.getCollapseStates(routes),
            openAvatar: false,
            width: window.innerWidth,
            userLoaded: false,
            userName: "",
            ssoOn: false
        };

        if (this.props.email === undefined) {
            routes = mauiRoutes.getRoutes();
        }
    }

    // this creates the intial state of this component based on the collapse routes
    // that it gets through this.props.routes
    getCollapseStates = routes => {
        let initialState = {};
        routes.map((prop) => {
            if (prop.collapse) {
                initialState = {
                    [prop.state]: this.getCollapseInitialState(prop.views),
                    ...this.getCollapseStates(prop.views),
                    ...initialState
                };
            }
            return null;
        });
        return initialState;
    };

    // this verifies if any of the collapses should be default opened on a rerender of this component
    // for example, on the refresh of the page,
    // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
    getCollapseInitialState(routes) {
        return routes.some(route => {
            if (route.collapse && this.getCollapseInitialState(route.views)) {
                return true;
            }
            const currentPath = window.location.href.toLowerCase();
            return currentPath.includes(route.path.toLowerCase());
        });
    }

    createAdminSettingLinks = routes => {
        return this.createLinks(routes, true, false);
    };

    createHelpLinks = routes => {
        return this.createLinks(routes, false, true);
    };

    //this function will decide the target is the subreport for each category
    isSubReportForTheCategory(categoryViews, targetUrl) {
        if (!Array.isArray(categoryViews)) return false;
        return categoryViews.some(view =>
            targetUrl.includes(view.path?.toLowerCase())
        );
    }

    // this function creates the links and collapses that appear in the sidebar (left menu)
    createLinks = (routes, admin, help) => {
        return routes.map((route, index) => {
            const {
                redirect,
                invisible,
                isAdmin,
                isHelp,
                collapse,
                layout,
                path,
                page = "",
                icon,
                name,
                views,
                state
            } = route;

            if (
                redirect ||
                invisible ||
                (admin && !isAdmin) ||
                (!admin && isAdmin) ||
                (help && !isHelp) ||
                (!help && isHelp)
            ) {
                return null;
            }

            const fullPath = layout + path + page;
            const currentPath = this.props.location.pathname.toLowerCase();
            const isOpen = this.isSubReportForTheCategory(views, currentPath);
            const shouldCollapse = isOpen || (this.state[state] && this.getCollapseInitialState(views));
            const caretClass = shouldCollapse ? "caret rotate-180" : "caret";

            if (collapse) {
                return (
                    <li className={this.getCollapseInitialState(views) ? "active" : ""} key={route.id || index}>
                        <NavLink
                            to={{ pathname: fullPath }}
                            aria-expanded={shouldCollapse}
                            className="nav-link d-flex align-items-center justify-content-between"
                            activeClassName="active"
                            onClick={() => {
                                this.setState({
                                    [state]: !this.state[state],
                                    openAvatar: false
                                });
                            }}
                        >
                            <div className="sidebarHeader d-flex align-items-center gap-2 flex-grow-1">
                                {icon && <i className={icon} />}
                                <span className="sidebar-normal">{this.props.t(`route.name:${name}`)}</span>
                            </div>
                            <span className={caretClass} />
                        </NavLink>

                        <Collapse in={shouldCollapse}>
                            <div>
                                <Nav as="ul">{this.createLinks(views, false, false)}</Nav>
                            </div>
                        </Collapse>
                    </li>
                );
            }

            return (
                <li className={this.activeRoute(layout + path)} key={route.id || index}>
                    <NavLink
                        to={{ pathname: layout + path }}
                        className="nav-link d-flex align-items-center gap-2 sidebar-button"
                        activeClassName="active"
                        onClick={() => this.setState({ openAvatar: false })}
                    >
                        {icon ? (
                            <div className="sidebarHeader d-flex align-items-center gap-2 flex-grow-1">
                                <i className={icon} />
                                <span className="sidebar-normal">{this.props.t(`route.name:${name}`)}</span>
                            </div>
                        ) : (
                            <>
                                <span className="me-4" aria-hidden="true">&nbsp;</span>
                                <span className="sidebar-normal">
                                    {this.props.t(`report.name:${capitalizeWords(name)}`)}
                                </span>
                            </>
                        )}
                    </NavLink>
                </li>
            );
        });
    };

    // verifies if routeName is the one active (in browser input)
    activeRoute = (routeName) => {
        const currentPath = this.props.location.pathname.toLowerCase();
        const normalizedRoute = routeName.toLowerCase();

        const isProjectGroup =
            normalizedRoute === "/admin/projects" &&
            ["/admin/newproject", "/admin/editproject", "/admin/viewproject"].includes(currentPath);

        const isMatch = currentPath.includes(normalizedRoute);

        return isProjectGroup || isMatch ? "active" : "";
    };

    // if the windows width changes CSS has to make some changes
    // this functions tell react what width is the window
    updateDimensions() {
        this.setState({width: window.innerWidth});
    }

    updateSessionLanguage = ({language}) => {
        API.setSessionLanguage({sessionLanguage: language});
        this.props.i18n.changeLanguage(language);
    };

    loadUserInfo() {
        let _this = this;
        API.user
            .get("/user/info")
            .then(resp => {
                const {data: resData} = resp;
                const {data} = resData;
                _this.setState({
                    userName: data.fullName,
                    supportAccount: data.supportAccount,
                    loginAs: data.loginAs,
                    userLoaded: true,
                    ssoOn: data.sso
                });

                let userTimeZone = data.userTimezone;
                if(userTimeZone == null || userTimeZone=== "") {
                    userTimeZone = data.serverTimezone.zoneId==null|| data.serverTimezone.zoneId==="" ? getPossibleTimezone().value : data.serverTimezone.zoneId;
                }
                API.setUserTimeZone( userTimeZone );
                API.setServerTimeZone(data.serverTimezone.zoneId);

                // console.log("serverTimezone: "+ (data.serverTimezone !==null ? JSON.stringify(data.serverTimezone): null));
                _this.updateSessionLanguage({language: data.language});
                window.sessionStorage.setItem("currentUser", data.fullName);
            }).catch(e => {
            console.error(e);
            if (localStorage.get("accessDenied401") === "true") {
                window.location.href = "/#/auth/logout";
            }
        });
    }

    componentDidMount() {
        this.loadUserInfo();
        this.updateDimensions();
        // add event listener for windows resize
        window.addEventListener("resize", this.updateDimensions.bind(this));
        // if you are using a Windows Machine, the scrollbars will have a Mac look
        if (navigator.platform.indexOf("Win") > -1) {
            ps = this.refs.sidebarWrapper;
        }
    }

    handleClick = (e) => {
        if (this.props.handleSidebarClick) {
            this.props.handleSidebarClick(e.currentTarget.id);
        }
    }

    render() {
        const {email, csRoutes, currentRoute, t} = this.props;

        let logoClass = 'logo text-center align-middle';
        let sidebarWrapperClass = 'sidebar-wrapper knoa-region';
        let infoClass = 'info';
        let userLinkClass = 'user-name-wrap';
        let userCaretClass = 'caret';
        let userName;
        let supportAccount;
        if (email) {
            userName = "";
            supportAccount = "";
        } else {
            userName = this.state.userName;
            supportAccount = this.state.supportAccount;
        }

        const caretClass = this.state.loginAs ? userCaretClass : "caret";
        const caretRotation = (this.state.openAvatar ||
            ["/admin/myProfile", "/admin/password", "/admin/myPreference"].some(path =>
                window.location.href.includes(path)
            )) ? "rotate-180" : "";
        const caretFullClass = `${caretClass} ${caretRotation}`;

        const displayName = this.state.loginAs
            ? t('common:loggedInAs', { user1: supportAccount, user2: userName })
            : this.state.userLoaded ? userName : "";

        if (email) {
            return (
                <aside className="sidebar" role="navigation">
                    <div className="sidebar-wrapper csSidebar-wrapper knoa-region" tabIndex="-1">
                        <div className="logo csLogo text-center align-middle">
                            <div className="simple-text logo-normal sidebarTitle">
                                KNOA SUPPORT
                            </div>
                        </div>

                        <div className="user csMainUser">
                            <div className="photo user-photo-maui">
                                <img alt="Avatar" src={avatar} />
                            </div>

                            <div className="csInfo">
                                <span>{email}</span>
                                <nav>
                                    <ul className="nav">
                                        <li className="csLogoutLI">
                                            <NavLink
                                                to={{
                                                    pathname: "/auth/logout",
                                                    state: { session: false }
                                                }}
                                                className="nav-link"
                                                activeClassName="active"
                                            >
                                                <span className="me-2 csLogoutSPAN">&nbsp;</span>
                                                <span className="sidebar-normal">Log out</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>

                        <nav>
                            <ul className="nav">
                                <GenerateSidebarLinks
                                    csRoutes={csRoutes}
                                    currentRoute={currentRoute}
                                    handleClick={this.handleClick}
                                />
                            </ul>
                        </nav>
                    </div>

                    <div className="sidebar-background" />
                </aside>
            );
        } else {
            if (document.body.classList.contains("sidebar-mini")) {
                sidebarWrapperClass = sidebarWrapperClass + ' sidebar-wrapper-mini';
            }

            if (this.state.userLoaded && this.state.loginAs) {
                logoClass = logoClass + ' csLogo';
                sidebarWrapperClass = sidebarWrapperClass + ' csSidebar-wrapper';
                infoClass = infoClass + ' csInfo';
                userLinkClass = 'user-name-wrap csUserA';
                routes = mauiRoutes.getRoutes();
            }

            return (
                <aside className="sidebar" role="navigation" data-color={this.props.color} data-image={this.props.image}>
                    <div className={`${sidebarWrapperClass}`} ref={this.sidebarWrapperRef} tabIndex={"-1"}>
                        <div className="sidebar-fixed-top">
                            <div className={`${logoClass}`}>
                                <div className="simple-text logo-normal sidebarTitle">
                                    {t('common:appName')}
                                </div>
                            </div>
                        </div>

                        <div className="sidebar-scrollable-content">
                            <div className="user user-display-wrap">
                                <div className="photo user-photo-maui">
                                    <img alt="Avatar"
                                         src={avatar}
                                         className={
                                             this.state.openAvatar ||
                                             ["/admin/myProfile", "/admin/password", "/admin/myPreference"].some(path =>
                                                 window.location.href.includes(path)
                                             )
                                                 ? "profile-highlight"
                                                 : ""
                                         }
                                    />
                                </div>

                                <div className={`${infoClass}`}>
                                    <a
                                        href="#"
                                        role="button"
                                        onClick={e => {
                                            e.preventDefault();
                                            if(!this.state.openAvatar) {
                                                this.setState({ openAvatar: !this.state.openAvatar });
                                            }
                                        }}
                                        className={`${userLinkClass} d-flex align-items-center justify-content-between`}
                                        aria-expanded={this.state.openAvatar}
                                    >
                                        <div className="user-name-wrap flex-grow-1">
                                            <span>
                                              <b className="support-user-sidebar-proxyTitle">{displayName}</b>
                                            </span>
                                        </div>
                                        <i className={caretFullClass} />
                                    </a>

                                    <Collapse
                                        in={
                                            this.state.openAvatar ||
                                            ["/admin/myProfile", "/admin/password", "/admin/myPreference"].some(path =>
                                                window.location.href.includes(path)
                                            )
                                        }
                                    >
                                        <div>
                                            <Nav as="ul">
                                                {[
                                                    { path: "/admin/myProfile", label: t('route.name:My Profile') },
                                                    { path: "/admin/password", label: t('user:password') },
                                                    { path: "/admin/myPreference", label: t('route.name:My Preferences') }
                                                ].map(({ path, label }) => (
                                                    <li key={path} className={window.location.href.includes(path) ? "active" : ""}>
                                                        <NavLink
                                                            to={{ pathname: path }}
                                                            className="nav-link nav-link-user"
                                                            activeClassName="active"
                                                            onClick={() => this.createLinks(routes, false, false)}
                                                        >
                                                            <span className="sidebar-normal">{label}</span>
                                                        </NavLink>
                                                    </li>
                                                ))}

                                                {this.state.loginAs && (
                                                    <li>
                                                        <NavLink
                                                            to={{
                                                                pathname: "/auth/proxySessionChange",
                                                                state: { session: false, email: supportAccount }
                                                            }}
                                                            className="nav-link nav-link-user"
                                                            activeClassName="active"
                                                        >
                                                            <span className="sidebar-normal">{t('route.name:ProxySessionChange')}</span>
                                                        </NavLink>
                                                    </li>
                                                )}
                                                {!this.state.ssoOn &&
                                                <li>
                                                    <NavLink
                                                        to={{ pathname: "/auth/logout", state: { session: false } }}
                                                        className="nav-link nav-link-user"
                                                        activeClassName="active"
                                                    >
                                                        <span className="sidebar-normal">{t('route.name:logOut')}</span>
                                                    </NavLink>
                                                </li>
                                                }
                                            </Nav>
                                        </div>
                                    </Collapse>
                                </div>
                            </div>

                            <BuildSideBarMenus
                                width={this.state.width}
                                loaded={this.state.userLoaded}
                                createLinks={this.createLinks}
                                createAdminSettingLinks={this.createAdminSettingLinks}
                                createHelpLinks={this.createHelpLinks}
                                trans={t}
                            />
                        </div>
                    </div>

                    <div
                        className="sidebar-background"
                        style={{
                            backgroundImage: `url('${this.props.image}')`
                        }}
                    />
                </aside>
            );
        }
    }
}

export default withTranslation()(Sidebar);